import { render } from "./UigeaPage.vue?vue&type=template&id=c3dfcbca&scoped=true"
import script from "./UigeaPage.vue?vue&type=script&lang=js"
export * from "./UigeaPage.vue?vue&type=script&lang=js"

import "./UigeaPage.vue?vue&type=style&index=0&id=c3dfcbca&scoped=true&lang=css"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3dfcbca"]])

export default __exports__